<script>
    import closeIcon from './closeIcon';
    import infoIcon from './infoIcon';
    import showNote from '../utilities/showNote';

    export default {
        name: 'mealsTable',

        components: {closeIcon, infoIcon},

        props: {
            mealPlans: null,
            mealPlansCount: null,
            isCalc: null,
            termText: {
                default: 'semester'
            },
            selectedMealPlan: null
        },

        computed: {
            selectedMealPlanId: function() {
                return this.selectedMealPlan ? this.selectedMealPlan.id : null
            }
        },

        methods: {

          showNote,

          selectPlan(id) {

            if(!this.isCalc) return false;

            this.$emit('select-meal-plan', id);

            // close all open notes
            const rowsWithOpenNotes = this.$el.querySelectorAll('tr.is-open');

            rowsWithOpenNotes.forEach( (row) => {
              row.classList.remove('.is-open');
              const noteRow = row.nextElementSibling;
              noteRow.parentNode.removeChild(noteRow);
            });

          }

        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <div class="a-tableWrapperSlider">
            <table id="tf-table--meals" class="a-table--responsive a-table tf-table" :class="{active:isCalc}">
                <thead>
                <tr>
                    <th v-if="isCalc"></th>
                    <th>Name</th>
                    <th></th>
                    <th>Cost (per {{termText}})</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="plan in mealPlans" :key="plan.id" :class="{highlight:plan.id === selectedMealPlanId}">
                    <td v-if="isCalc" class="tableCheckBox" @click="selectPlan(plan.id)">
                        <div><span></span></div>
                    </td>
                    <td :class="{'tf-hasNote': plan.notes}" @click="showNote(plan, $event, 4)">{{plan.name + '&nbsp;'}}<infoIcon v-if="plan.notes"/></td>
                    <td></td>
                    <td>{{plan.costPerTerm | toCurrency}}</td>
                </tr>
                </tbody>
            </table>
            <div v-if="isCalc && selectedMealPlan && mealPlansCount > 1" @click="selectPlan(selectedMealPlanId)" class="tf-clearSelection"><closeIcon />Clear selection</div>
        </div>
    </div>
</template>

